import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isInfoPath } from '../content/index.js';
import { MAX_COMPARE, useCompare } from './CompareContext.js';

export default function CompareTray() {
  const { items, remove, clear, limitMessage } = useCompare();
  const location = useLocation();

  if (items.length === 0 || isInfoPath(location.pathname) || location.pathname === '/compare') {
    return null;
  }

  const ready = items.length >= 2;
  const href = `/compare?c=${items.map((item) => encodeURIComponent(item.slug)).join(',')}`;

  return (
    <aside className="compare-tray" aria-label="Programmes selected for comparison">
      <div className="container compare-tray-inner">
        <div className="compare-tray-items">
          {items.map((item) => (
            <span className="compare-chip" key={item.slug}>
              <span className="compare-chip-text">
                <strong>{item.name}</strong>
                {item.universityName ? <small>{item.universityName}</small> : null}
              </span>
              <button
                type="button"
                className="compare-chip-remove"
                onClick={() => remove(item.slug)}
                aria-label={`Remove ${item.name} from comparison`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
        <div className="compare-tray-actions">
          <span className="compare-tray-hint" role="status">
            {limitMessage ||
              (ready
                ? `${items.length} of ${MAX_COMPARE} selected`
                : 'Add one more programme to compare')}
          </span>
          <button type="button" className="link-button" onClick={clear}>
            Clear
          </button>
          {ready ? (
            <Link className="cta-button" to={href}>
              Compare {items.length} programmes
            </Link>
          ) : (
            <span className="cta-button disabled" aria-disabled="true">
              Compare
            </span>
          )}
        </div>
      </div>
    </aside>
  );
}
